import './public-path';
import { picoapp } from 'picoapp';
import AppComponents from './AppComponents';
import AppState from './AppState';
// import common from './features/common';
// import icons from './features/icons';
// import webfonts from './features/webfonts';
const app = picoapp(AppComponents, AppState);
import '../sass/theme.scss';

app.mount(['data-component']);

window.app = app;
// common.init(app);
// icons.init();
// webfonts.init();

// Remount components on section re-renders
document.addEventListener('shopify:section:load', () => {
  app.mount(['data-component']);
});
